import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { MetaData } from '../../components/common/meta'
import Layout from '../../components/Layout'

function Page({ data, location }) {
  const page = data.ghostPage

  const content = page.html.replaceAll(process.env.GATSBY_GHOST_API_URL, '')

  return (
    <>
      <MetaData data={data} location={location} type="website" />
      <Helmet>
        <style type="text/css">{`${page.codeinjection_styles}`}</style>
      </Helmet>
      <Layout>
        <article className="page type-page status-publish hentry">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </article>
      </Layout>
    </>
  )
}

Page.propTypes = {
  data: PropTypes.shape({
    ghostPage: PropTypes.shape({
      codeinjection_styles: PropTypes.string,
      title: PropTypes.string.isRequired,
      feature_image: PropTypes.string,
      html: PropTypes.string.isRequired,
    }).isRequired,
    allGhostPost: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          published_at: PropTypes.string.isRequired,
          excerpt: PropTypes.string.isRequired,
        }),
      ),
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default Page
